// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { z } from 'zod'

export const sagaSyncLogSchema = z.object({
  id: z.string().max(200),
  orgId: z.string().max(100),
  workspaceId: z.string().max(100).optional(),

  agentId: z.string().max(200),
  systemId: z.string().max(100),
  direction: z.enum(['push', 'pull', 'hub-push', 'hub-pull']),
  collectionName: z.string().max(100),
  documentCount: z.number().int().min(0).default(0),
  checkpointBefore: z.record(z.string(), z.unknown()).optional(),
  checkpointAfter: z.record(z.string(), z.unknown()).optional(),
  status: z.enum(['success', 'partial', 'failed']),
  rejectedCount: z.number().int().min(0).default(0),
  rejectionReasons: z.array(z.string()).optional(),

  createdAt: z.string().max(200).datetime(),
})

export type SagaSyncLogInput = z.infer<typeof sagaSyncLogSchema>
